export const mapStyles = [
	{
		featureType: 'administrative',
		elementType: 'geometry',
		stylers: [
			{
				color: '#a7a7a7',
			},
		],
	},
	{
		featureType: 'administrative',
		elementType: 'labels.text.fill',
		stylers: [
			{
				visibility: 'on',
			},
			{
				color: '#737373',
			},
		],
	},
	{
		featureType: 'landscape',
		elementType: 'all',
		stylers: [
			{
				visibility: 'on',
			},
		],
	},
	{
		featureType: 'landscape',
		elementType: 'geometry.fill',
		stylers: [
			{
				visibility: 'on',
			},
			{
				color: '#efefef',
			},
		],
	},
	{
		featureType: 'landscape',
		elementType: 'labels.icon',
		stylers: [
			{
				visibility: 'off',
			},
		],
	},
	{
		featureType: 'poi',
		elementType: 'all',
		stylers: [
			{
				visibility: 'on',
			},
		],
	},
	{
		featureType: 'poi',
		elementType: 'geometry.fill',
		stylers: [
			{
				visibility: 'on',
			},
			{
				color: '#dadada',
			},
		],
	},
	{
		featureType: 'poi',
		elementType: 'labels',
		stylers: [
			{
				visibility: 'off',
			},
		],
	},
	{
		featureType: 'poi',
		elementType: 'labels.text',
		stylers: [
			{
				saturation: '0',
			},
		],
	},
	{
		featureType: 'poi',
		elementType: 'labels.icon',
		stylers: [
			{
				visibility: 'off',
			},
		],
	},
	{
		featureType: 'poi.park',
		elementType: 'labels.icon',
		stylers: [
			{
				visibility: 'off',
			},
		],
	},
	{
		featureType: 'road',
		elementType: 'labels.text.fill',
		stylers: [
			{
				color: '#696969',
			},
		],
	},
	{
		featureType: 'road',
		elementType: 'labels.icon',
		stylers: [
			{
				visibility: 'off',
			},
		],
	},
	{
		featureType: 'road.highway',
		elementType: 'geometry.fill',
		stylers: [
			{
				color: '#ffffff',
			},
		],
	},
	{
		featureType: 'road.highway',
		elementType: 'geometry.stroke',
		stylers: [
			{
				visibility: 'on',
			},
			{
				color: '#b3b3b3',
			},
		],
	},
	{
		featureType: 'road.arterial',
		elementType: 'geometry.fill',
		stylers: [
			{
				color: '#ffffff',
			},
		],
	},
	{
		featureType: 'road.arterial',
		elementType: 'geometry.stroke',
		stylers: [
			{
				color: '#d6d6d6',
			},
		],
	},
	{
		featureType: 'road.local',
		elementType: 'geometry.fill',
		stylers: [
			{
				visibility: 'on',
			},
			{
				color: '#ffffff',
			},
			{
				weight: 1.8,
			},
		],
	},
	{
		featureType: 'road.local',
		elementType: 'geometry.stroke',
		stylers: [
			{
				color: '#d7d7d7',
			},
		],
	},
	{
		featureType: 'transit',
		elementType: 'all',
		stylers: [
			{
				color: '#808080',
			},
			{
				visibility: 'off',
			},
		],
	},
	{
		featureType: 'water',
		elementType: 'geometry.fill',
		stylers: [
			{
				color: '#d3d3d3',
			},
		],
	},
	{
		featureType: 'water',
		elementType: 'labels.text',
		stylers: [
			{
				saturation: '-100',
			},
		],
	},
];

export function markerIcon(highlight?: boolean) {
	if (highlight) {
		return '<svg xmlns="http://www.w3.org/2000/svg" width="68" height="68"><defs><filter id="a" x="0" y="0" width="68" height="68" filterUnits="userSpaceOnUse"><feOffset dy="1"/><feGaussianBlur stdDeviation="3" result="blur"/><feFlood flood-opacity=".451"/><feComposite operator="in" in2="blur"/><feComposite in="SourceGraphic"/></filter></defs><g data-name="Group 50185"><g data-name="Group 46500"><path data-name="Polygon 452" d="M34.894 64.211a1 1 0 0 1-1.789 0l-4.382-8.764A1 1 0 0 1 29.618 54h8.764a1 1 0 0 1 .894 1.447Z"/><g filter="url(#a)"><circle data-name="Ellipse 4088" cx="25" cy="25" r="25" transform="translate(9 8)" fill="#bdff3b"/></g></g><path data-name="Path 16129" d="m37.202 25.133-.267 1.507a3.023 3.023 0 0 0-2.995-1.66c-2.613 0-5.055 2.1-5.646 5.455s1.106 5.494 3.72 5.494a4.619 4.619 0 0 0 3.239-1.3l.265.089-.185 1.043a2.577 2.577 0 0 1-2.652 2.441c-1.125 0-1.831-.515-1.907-1.316h-3.223c-.172 2.537 1.6 4.139 4.788 4.139a6.081 6.081 0 0 0 6.256-5.265l1.869-10.625Zm-5.589 5.3a2.924 2.924 0 0 1 2.785-2.613c1.24 0 2.175.934 1.869 2.632a2.96 2.96 0 0 1-2.8 2.632c-1.223.003-2.159-.951-1.854-2.649Z"/></g></svg>';
	}
	return '<svg xmlns="http://www.w3.org/2000/svg" width="68" height="68"><defs><filter id="a" x="0" y="0" width="68" height="68" filterUnits="userSpaceOnUse"><feOffset dy="1"/><feGaussianBlur stdDeviation="3" result="blur"/><feFlood flood-opacity=".451"/><feComposite operator="in" in2="blur"/><feComposite in="SourceGraphic"/></filter></defs><g data-name="Group 50184"><g transform="translate(9 8)"><g data-name="Group 46499"><path data-name="Polygon 452" d="M25.894 56.211a1 1 0 0 1-1.789 0l-4.382-8.764A1 1 0 0 1 20.618 46h8.764a1 1 0 0 1 .894 1.447Z"/><g transform="translate(-9 -8)" filter="url(#a)"><circle data-name="Ellipse 4088" cx="25" cy="25" r="25" transform="translate(9 8)" fill="#fff"/></g></g><circle data-name="Ellipse 4247" cx="22" cy="22" r="22" transform="translate(3 3)" fill="#e5e5e5"/></g><path data-name="Path 16129" d="m37.202 25.133-.267 1.507a3.023 3.023 0 0 0-2.995-1.66c-2.613 0-5.055 2.1-5.646 5.455s1.106 5.494 3.72 5.494a4.619 4.619 0 0 0 3.239-1.3l.265.089-.185 1.043a2.577 2.577 0 0 1-2.652 2.441c-1.125 0-1.831-.515-1.907-1.316h-3.223c-.172 2.537 1.6 4.139 4.788 4.139a6.081 6.081 0 0 0 6.256-5.265l1.869-10.625Zm-5.589 5.3a2.924 2.924 0 0 1 2.785-2.613c1.24 0 2.175.934 1.869 2.632a2.96 2.96 0 0 1-2.8 2.632c-1.223.003-2.159-.951-1.854-2.649Z" fill="#fff"/></g></svg>';
}
export function markerFromImage(imageDataUrl?: string, highlight?: boolean) {
	if (!imageDataUrl) {
		return markerIcon(highlight);
	}

	const fill = highlight ? '#BDFF3B' : '#FFF';
	let imagePart = '';
	if (imageDataUrl) {
		imagePart =
			'<pattern id="c" preserveAspectRatio="none" width="100%" height="100%" viewBox="0 0 64 48"><image width="64" height="48" xlink:href="' +
			imageDataUrl +
			'"/></pattern>';
	}
	return (
		'<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="68" height="68">' +
		'<defs>' +
		'<clipPath id="b"><circle cx="22" cy="22" r="22" transform="translate(1268 554)" fill="rgba(153,28,191,0.95)"/></clipPath>' +
		imagePart +
		'<filter id="a" x="0" y="0" width="68" height="68" filterUnits="userSpaceOnUse"><feOffset dy="1"/><feGaussianBlur stdDeviation="3" result="blur"/><feFlood flood-opacity=".451"/><feComposite operator="in" in2="blur"/><feComposite in="SourceGraphic"/></filter>' +
		'</defs>' +
		'<path d="M34.894 64.211a1 1 0 0 1-1.789 0l-4.382-8.764A1 1 0 0 1 29.618 54h8.764a1 1 0 0 1 .894 1.447Z"/>' +
		'<g filter="url(#a)"><circle cx="25" cy="25" r="25" transform="translate(9 8)" fill="' +
		fill +
		'"/></g>' +
		'<g clip-path="url(#b)" transform="translate(-1256 -543)"><path transform="translate(1257 551)" fill="url(#c)" d="M0 0h67v50H0z"/></g>' +
		'</svg>'
	);
}

/**
 *
 * @param lat1 first point latitude
 * @param lng1 first point longitude
 * @param lat2 second point latitude
 * @param lng2 second point longitude
 * @returns Distance in km
 */
export function haversine_distance(lat1: number, lng1: number, lat2: number, lng2: number): number {
	var R = 6371; // Radius of the Earth in km
	var rlat1 = lat1 * (Math.PI / 180); // Convert degrees to radians
	var rlat2 = lat2 * (Math.PI / 180); // Convert degrees to radians
	var difflat = rlat2 - rlat1; // Radian difference (latitudes)
	var difflon = (lng2 - lng1) * (Math.PI / 180); // Radian difference (longitudes)

	var d =
		2 *
		R *
		Math.asin(
			Math.sqrt(
				Math.sin(difflat / 2) * Math.sin(difflat / 2) +
					Math.cos(rlat1) * Math.cos(rlat2) * Math.sin(difflon / 2) * Math.sin(difflon / 2),
			),
		);
	return d;
}
